import GraphQLModel from './graphQLModel'
import { cleanString } from '@polleverywhere/core/lib/util'

export default class GraphQLPoll extends GraphQLModel {
  remainingVotes (responseCount) {
    return Math.max((this.get('max_votes') || Infinity) - responseCount, 0)
  }

  cleanTitle (opts = {}) {
    const title = this.get('title')
    return cleanString(title, opts)
  }

  isStarted () {
    return /opened/i.test(this.get('state'))
  }

  isStopped () {
    return /closed/i.test(this.get('state'))
  }

  isMaxedOut () {
    return /maxed_out/i.test(this.get('state'))
  }

  isWebEnabled () {
    return !!this.get('web_enabled')
  }

  requiresRegistration () {
    return !!this.get('registered_participants_only')
  }
}
